'use client';

import { c as _c } from "react/compiler-runtime";
import type { PrV2SummaryResponse } from '@/lib/pr-v2/types';
import { useEffect, useRef } from 'react';
import { offerInstallPrompt } from './install-prompt-store';

/** A pull request with this many reviews or comments has outgrown GitHub threads. */
export const BUSY_PR_REVIEWS = 3;
export const BUSY_PR_COMMENTS = 20;

/** Offers a Slack channel, once per page, for an open pull request with a busy discussion. */
export function useBusyPrInstallPrompt(pullRequest, enabled) {
  const $ = _c(4);
  const offeredRef = useRef(null);
  let t0;
  let t1;
  if ($[0] !== enabled || $[1] !== pullRequest) {
    t0 = () => {
      if (!enabled || !pullRequest || pullRequest.state !== "open" || !pullRequest.title) {
        return;
      }
      const {
        owner,
        repo,
        number,
        title,
        counts
      } = pullRequest;
      const key = `${owner}/${repo}#${number}`;
      if (offeredRef.current === key) {
        return;
      }
      if (counts.reviews < BUSY_PR_REVIEWS && counts.comments < BUSY_PR_COMMENTS) {
        return;
      }
      offeredRef.current = key;
      offerInstallPrompt({
        id: "busy-pr",
        pullRequest: {
          owner,
          repo,
          number,
          title
        },
        reviews: counts.reviews,
        comments: counts.comments
      });
    };
    t1 = [enabled, pullRequest];
    $[0] = enabled;
    $[1] = pullRequest;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}